import Cookies from "js-cookie";
import { getGuiaPorCodigo } from "./guiasServices.js";

async function comissoesLojas(dataI, dataF) {
    try {
        let dia = new Date(dataI + "T00:00:00-03:00");
        const fim = new Date(dataF + "T00:00:00-03:00");
        let respostas = [];
        let comissionadas = [];

        while (dia <= fim) {
            respostas.push(fetch(`/api/chef/comissoes/${dia.toISOString().split("T")[0]}`, {
                method: "get",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + Cookies.get("token_tour")
                }
            }).then(resposta => resposta.json()).then(resposta => comissionadas.push(...resposta)));
            dia.setDate(dia.getDate() + 1);
        }
        await Promise.all(respostas);
        let comissoesChef = comissionadas
            .filter((venda, indice) => comissionadas.findIndex(e => e.guia.codigo === venda.guia.codigo) === indice)
            .map(venda => {
                return {
                    guia: venda.guia,
                    atendimentosTour: 0,
                    atendimentosCentro: 0,
                    comissaoLojaTour: 0,
                    comissaoLojaCentro: 0
                }
            });
        comissionadas.forEach(venda => {
            let i = comissoesChef.findIndex(e => e.guia.codigo === venda.guia.codigo);
            if (venda.loja === 1) {
                comissoesChef[i].comissaoLojaTour += venda.valor * 0.05;
                comissoesChef[i].atendimentosTour++;
            } else {
                comissoesChef[i].comissaoLojaCentro += venda.valor * 0.05;
                comissoesChef[i].atendimentosCentro++;
            }
        });
        // comissoesChef[comissoesChef.findIndex(e => e.guia.codigo === 480)].comissaoLojaTour -= 30;      // Remoção de valor pago adiantado
        return comissoesChef;
    } catch (e) {
        console.log(e.message);
        return [];
    }
}

async function comissoesTour(dataI, dataF) {
    try {
        // Variável de controle de todos os tipos de ingresso que devem ser comissionados
        const tiposComissionados = [
            "INDIVIDUAL",
            "INDIVIDUAL-ONLINE",
            "PROMOCIONAL",
            "PROMOCIONAL-ONLINE",
            "PROMOCIONAL-EXCURSÃO",
            "PROMOCIONAL-EXCURSAO"
        ];

        // Obtém todos os ingressos que possuem um guia relacionado
        const resposta = await fetch(`/api/tickets/comissionados?dataInicial=${dataI}&dataFinal=${dataF}`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        });

        // Se não encontrou ingressos, retorna array vazio de comissões
        if (resposta.status !== 200) return [];

        // Transforma a resposta em JSON
        const tickets = (await resposta.json()).tickets;

        // Tratamento dos ingressos
        let comissoes = tickets
            // Filtra registros do mesmo guia para manter apenas 1 linha para cada guia
            .filter((ticket, index) => tickets.findIndex(e => e.guia.codigo === ticket.guia.codigo) === index)
            // Normaliza para cada registro ter o valor da comissão e os dados do guia
            .map(ticket => {
                return {
                    guia: {
                        codigo: ticket.guia.codigo,
                        nome: ticket.guia.nome
                    },
                    comissaoTour: 0
                }
            });

        // Percorre novamente os ingressos obtidos para somar os valores de comissão de acordo com o tipo do ingresso
        tickets.forEach(ticket => {
            // Obtém a posição do guia atual
            let i = comissoes.findIndex(e => e.guia.codigo === ticket.guia.codigo);

            // Verifica se é um tipo comissionado
            if (tiposComissionados.includes(ticket.tipo)) {
                comissoes[i].comissaoTour += 6;
            } else if (ticket.tipo === "PROMOCIONAL-ESCOLAR") {
                comissoes[i].comissaoTour += 3;
            }
        });
        // comissoes[comissoes.findIndex(e => e.guia.codigo === 480)].comissaoTour -= 45;      // Remoção de valor pago adiantado
        
        // Retorna apenas comissões que são maiores que zero
        return comissoes.filter(com => com.comissaoTour > 0);
    } catch (e) {
        console.log(e.message);
        return [];
    }
}

export async function getComissoes(dataI, dataF) {
    try {
        // Cria os cálculos de comissões
        const comissoesPromessas = [comissoesLojas(dataI, dataF), comissoesTour(dataI, dataF)];
        // Espera os cálculos resolverem
        const dados = await Promise.all(comissoesPromessas);

        // Variáveis auxiliares
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        const data = new Date(Date.now());
        const dataHora = zeroPad(data.getDate(), 2) + zeroPad(data.getMonth() + 1, 2) + data.getFullYear() + zeroPad(data.getHours(), 2) + zeroPad(data.getMinutes(), 2) + zeroPad(data.getSeconds(), 2);

        // Percorre as comissões do tour para iniciar vetor unificado das comissões
        dados[1].forEach(comissaoTour => {
            let i = dados[0].findIndex(element => element.guia.codigo === comissaoTour.guia.codigo);
            if (i === -1) {
                dados[0].push({
                    guia: comissaoTour.guia,
                    comissaoTour: comissaoTour.comissaoTour,
                    comissaoLojaCentro: 0,
                    comissaoLojaTour: 0
                })
            } else {
                dados[0][i].comissaoTour = comissaoTour.comissaoTour
            }
        });
        let j = 0;
        const comissoes = await Promise.all(dados[0].map(async com => {
            if (!com.comissaoTour) com.comissaoTour = 0;
            let guia = await getGuiaPorCodigo(com.guia.codigo);
            if (!guia) console.log(`Guia ${com.guia.codigo} não encontrado.`)
            com.guia.id = guia._id;
            com.guia.tipoChavePix = guia.tipoChavePix;
            com.guia.chavePix = guia.chavePix;
            com.guia.cpfCnpjBeneficiario = guia.cpfCnpjBeneficiario;
            com.comissaoLojaTour = Number(com.comissaoLojaTour.toFixed(2));
            com.comissaoLojaCentro = Number(com.comissaoLojaCentro.toFixed(2));
            com.comissaoTotal = com.comissaoTour + com.comissaoLojaCentro + com.comissaoLojaTour;
            com.dataInicial = new Date(dataI);
            com.dataFinal = new Date(dataF);
            com.dataPagamento = data;
            com.pagamentoEfetivado = false;
            com.mensagem = "Etapa 1 de 3";
            com.identificador = dataHora + j;
            j++;
            return com;
        }));

        /*
        // Ajuste nas comissões
        const guiaOrigem = 916;
        const guiaDestino = 419;
        const de = comissoes.findIndex(com => com.guia.codigo === guiaOrigem);
        const para = comissoes.findIndex(com => com.guia.codigo === guiaDestino);
        let valor = 406.76;

        if (de != -1 && para != -1) {
            // valor = comissoes[de].comissaoLojaTour;
            comissoes[de].comissaoLojaTour -= valor;
            comissoes[de].comissaoTotal -= valor;
            comissoes[para].comissaoLojaTour += valor;
            comissoes[para].comissaoTotal += valor;
        } else if (de != -1) {
            let guia = await getGuiaPorCodigo(guiaDestino);
            if (!guia) console.log(`Guia ${guiaDestino} não encontrado.`)
            comissoes.push({
                comissaoTour: 0,
                comissaoLojaCentro: 0,
                comissaoLojaTour: valor,
                comissaoTotal: valor,
                guia: {
                    codigo: guia.codigo,
                    nome: guia.nome,
                    id: guia._id,
                    tipoChavePix: guia.tipoChavePix,
                    chavePix: guia.chavePix,
                    cpfCnpjBeneficiario: guia.cpfCnpjBeneficiario
                },
                dataInicial: new Date(dataI),
                dataFinal: new Date(dataF),
                dataPagamento: data,
                pagamentoEfetivado: false,
                mensagem: "Etapa 1 de 3",
                identificador: dataHora + j
            });
        }
        */

        /*
        // Busca valores para correção das comissões
        // const valoresCorrecao = await comissoesParaCorrigir();

        const comissoesCorrigidas = comissoes.map(comissao => {
            const match = valoresCorrecao.find(el => el.guia.codigo === comissao.guia.codigo);
            if (match) {
                const amountToFix = Math.min(comissao.comissaoTotal, match.comissaoTotal);
                comissao.comissaoTotal -= amountToFix; // Deduct the fixed amount from comissoes
                match.comissaoTotal -= amountToFix;
            }
            return comissao;
        }).filter(com => com.comissaoTotal > 0);

        // Realiza o download de arquivo com os valores restantes de correção
        const jsonString = JSON.stringify(valoresCorrecao.filter(com => com.comissaoTotal > 0), null, 2); // Pretty print JSON

        // Create a Blob from the JSON string
        const blob = new Blob([jsonString], { type: "application/json" });

        // Create a download link
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "valoresRestantes.json"; // Filename for the download
        link.click();

        // Clean up URL object
        URL.revokeObjectURL(url);
        */

        return comissoes;
    } catch (e) {
        console.log(e.message);
        return [];
    }
}

// Função utilizada para buscar arquivo de correções quando há pagamentos adiantados realizados
/*
async function comissoesParaCorrigir() {
    try {
        const resposta = await (await fetch("/api/comissoes/correcoes", {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        })).json();

        if (resposta && resposta.status && resposta.status === 200) return resposta.correcoes;
        else return [];
    } catch (e) {
        console.log(e.message);
        return []
    }
}
*/

export async function obterComissoesSimplificadas(dataI, dataF) {
    try {
        console.log("Ober comissões simplificadas");
        return [];
        // const comissoesPromessas = [getComissoesChef(dataI, dataF), getComissoesMaycon(dataI, dataF)];
        // const dados = await Promise.all(comissoesPromessas);
        // dados[1].map( comissaoTour => {
        //     let i = dados[0].findIndex(element => element.guia.codigo === comissaoTour.guia.codigo);
        //     if (i == -1){
        //         dados[0].push({
        //             guia: comissaoTour.guia,
        //             comissaoTour: comissaoTour.comissaoTour,
        //             comissaoLojaCentro: 0,
        //             comissaoLojaTour: 0
        //         })
        //     } else {
        //         dados[0][i].comissaoTour = comissaoTour.comissaoTour
        //     }
        // });
        // return dados[0];
    } catch (e) {
        console.log(e.message);
        return [];
    }
}

export async function salvarComissoes(comissoes) {
    fetch("/api/comissoes", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + Cookies.get("token_tour")
        },
        body: JSON.stringify(comissoes)
    });
}

export async function enviarOcorrencias(identificador, ocor) {
    try {
        const resposta = await fetch(`/api/comissoes/ocorrencias/${identificador}`, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify(ocor)
        })
        return resposta.status;
    } catch (e) {
        console.log(e.message);
    }
}

export async function editarComissao(identificador, atualizacao) {
    try {
        fetch(`/api/comissoes/editar/${identificador}`, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify(atualizacao)
        });
    } catch (e) {
        console.log(e.message);
    }
}

export async function editarComissoes(filtro, atualizacao) {
    try {
        const resposta = await fetch("/api/comissoes", {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify({ comissoes: filtro, atualizacao: atualizacao })
        });

        return await resposta.json();
    } catch (e) {
        return { status: 400, mensagem: e.message };
    }
}

export async function getComissoesGuia(guia, pagina = 1, ordem = 1, ordenacao = "dataPagamento") {
    try {
        const resposta = await fetch(`/api/comissoes/guia/${guia}?pagina=${pagina}&ordem=${ordem}&ordenacao=${ordenacao}`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        });
        return await resposta.json();
    } catch (e) {
        console.log(e.message);
        return [];
    }
}

export async function getComissoesSalvas(nomeGuia, dataPagamento, pagina = 1, ordenacao = "dataPagamento", ordem = 1, limite = 30, pago) {
    try {
        let params = `limite=${limite}&ordenacao=${ordenacao}&ordem=${ordem}&pagina=${pagina}`
        if (nomeGuia) params += `&nomeGuia=${nomeGuia}`;
        if (dataPagamento) params += `&dataPagamento=${dataPagamento}`;
        if (pago) params += `&pagamentoEfetivado=${pago}`;
        const resposta = await fetch(`/api/comissoes/busca?${params}`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        });
        return await resposta.json();
    } catch (e) {
        console.log(e.message);
    }
}

export async function getComissoesManuais(nomeGuia, filtros, pagina = 1, ordenacao = "dataPagamento", ordem = 1, limite = 30, pago) {
    try {
        let params = `limite=${limite}&ordenacao=${ordenacao}&ordem=${ordem}&pagina=${pagina}`
        if (nomeGuia) params += `&nomeGuia=${nomeGuia}`;
        if (filtros.dataPagamento) params += `&dataPagamento=${filtros.dataPagamento}`;
        if (filtros.pagamentoEfetivado) params += `&pagamentoEfetivado=${filtros.pagamentoEfetivado}`;
        if (pago) params += `&pagamentoEfetivado=${pago}`;
        const resposta = await fetch(`/api/comissoes/manuais?${params}`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        });
        return await resposta.json();
    } catch (e) {
        console.log(e.message);
    }
}

export async function deletarComissoes(filtro) {
    try {
        const resposta = await fetch(`/api/comissoes/deletar`, {
            method: "delete",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify(filtro)
        });
        return await resposta.json();
    } catch (e) {
        return e.message;
    }
}

export async function removerResiduos() {
    try {
        const resposta = await fetch(`/api/comissoes/deletar`, {
            method: "delete",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify({
                mensagem: "Etapa 1 de 3"
            })
        });
        return await resposta.json();
    } catch (e) {
        console.log(e.message);
        return e.message;
    }
}

export async function buscaSelecionadas(selecionadas) {
    try {
        const resposta = await fetch("/api/selecionadas", {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify(selecionadas)
        });

        return await resposta.json();
    } catch (e) {
        console.log(e);
        return { status: 400, mensagem: e.message };
    }
}

// Função para marcar uma comissão como "comprovanteEnviado"
export async function marcarComprovanteEnviado(identificador) {
    try {
        const resposta = await fetch(`/api/comissoes/comprovante-enviado/${identificador}`, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        });
        if (resposta.status && resposta.status === 200) return true; else return false;
    } catch (e) {
        console.log(e.message);
        return false;
    }
}